import * as React from 'react'
import { connect, FormikProps, FormikState } from 'formik'
import produce from 'immer'

import { AttachmentSelector } from '@espoon-voltti/react-voltti/components/attachment-selector'
import { AttachmentModel } from '@espoon-voltti/react-voltti/components/attachment-selector/domain/model'

import { ProjectGrantDraftApp } from '../../../domain'

import {
  attachmentApiUrl,
  attachmentAuthProfile,
  attachmentService
} from '../../../services/attachment-service'
import { AttachmentEvent } from '@espoon-voltti/react-voltti/components/attachment-selector/domain/attachment-event'

export const Attachments = connect<{}, ProjectGrantDraftApp>(
  ({ formik }: { formik: FormikProps<ProjectGrantDraftApp> }) => {
    return (
      <>
        <AttachmentSelector
          attachmentApiUrl={attachmentApiUrl}
          authProfile={attachmentAuthProfile}
          onAdd={handleAdd(formik)}
          onDelete={handleDelete(formik)}
          models={formik.values.form.attachments}
        />
      </>
    )
  }
)

const handleAdd =
  (p: FormikProps<ProjectGrantDraftApp>) => (files: FileList) => {
    Promise.all(
      Array.from(files).map((file) =>
        attachmentService.addAttachment(
          file,
          p.values.form.attachments.map((x) => x.attachment.name),
          (newFileName) => `/grant-applications/${p.values.id}/${newFileName}`,
          async (e: AttachmentEvent.Type) => {
            switch (e.kind) {
              case 'Init':
              case 'InitError':
                return add(e.model)
              case 'Progress':
                return update(e.model)
              case 'Done':
                update(e.model)
                p.setFieldTouched('form.attachments', true)
                p.validateForm()
                return
              case 'LoadError':
                return update(e.model)
              default:
                const _: never = e
                return _
            }
          }
        )
      )
    )

    const add = (model: AttachmentModel): void => {
      p.setFormikState((prevState: FormikState<ProjectGrantDraftApp>) =>
        produce(prevState, (draft) => {
          draft.values.form.attachments.push(model)
        })
      )
    }

    const update = (model: AttachmentModel): void => {
      p.setFormikState((prevState: FormikState<ProjectGrantDraftApp>) =>
        produce(prevState, (draft) => {
          draft.values.form.attachments = prevState.values.form.attachments.map(
            (x) => (x.id === model.id ? model : x)
          )
        })
      )
    }
  }

const handleDelete =
  (p: FormikProps<ProjectGrantDraftApp>) => (model: AttachmentModel) => {
    p.setFormikState((prevState: FormikState<ProjectGrantDraftApp>) =>
      produce(prevState, (draft) => {
        draft.values.form.attachments =
          prevState.values.form.attachments.filter((x) => x.id !== model.id)
      })
    )

    p.validateField('form.attachments')
    p.setFieldTouched('form.attachments', true)
  }
